import { axiosApi } from './api'
import {
    invalidateIndicators,
    getFileIndicators,
    recacheIndicators,
} from 'features/patient-file-thumbnail/thumbnailSlice'

export const file = axiosApi.injectEndpoints({
    endpoints: build => ({
        /*
         * GET details of a file by id
         */
        getFile: build.query({
            query: ({ id, query }) => `v1/files/$hdp?FileIds=${id}${query}`,
            transformResponse: res => res.data[0],
        }),

        /*
         * GET summary and destructured count of files.
         */
        getFilesMeta: build.query({
            query: id => `v1/patients/${id}/files/$summary`,
            transformResponse: res => res.data,
            keepUnusedDataFor: 3600,
        }),

        /*
         * Get emails of users to whom the files are already shared with
         */
        getSharedWith: build.mutation({
            query: body => ({
                url: 'v1/share/_users',
                method: 'POST',
                body,
            }),
            transformResponse: res => res.data,
        }),

        /*
         * Share the files to users.
         */
        share: build.mutation({
            query: body => ({
                url: 'v1/share/manageFiles',
                method: 'POST',
                body,
            }),
            transformResponse: res => res.data,
            async onQueryStarted({ fileIds }, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    if (fileIds) {
                        await dispatch(invalidateIndicators(fileIds.split(',')))
                        dispatch(getFileIndicators({ ids: fileIds }))
                    } else {
                        dispatch(recacheIndicators())
                    }
                } catch {}
            },
        }),

        /*
         * Download the selected files or files from patient or collections.
         */
        download: build.mutation({
            query: body => ({
                url: 'v1/download',
                method: 'POST',
                body,
            }),
            transformResponse: res => res.data,
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetFileQuery,
    useGetFilesMetaQuery,
    useGetSharedWithMutation,
    useShareMutation,
    useDownloadMutation,
} = file
